import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import { mergeMap, filter } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  GetAssetStatus,
  GetAssetStatusSuccess,
  GetAssetStatusError,
} from '../action-creators';
import { GET_ASSET_STATUS } from '../actions';
import { getStatus } from '../../../sdk/assets';

export const getAssetStatusEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, GetAssetStatus>(GET_ASSET_STATUS),
    filter((action) => action.ids.length > 0),
    mergeMap(async (action) => {
      try {
        const results = await getStatus(action.category, action.ids);

        return new GetAssetStatusSuccess(
          action.category,
          results,
          action.retryCounter
        );
      } catch (e) {
        return new GetAssetStatusError(
          action.category,
          e.message,
          action.retryCounter
        );
      }
    })
  );
